import { useOnboarding } from '../context/OnboardingContext';

export function useOnboardingProgress() {
  const {
    progress,
    sections,
    completedCount,
    totalCount,
    activeCount,
    percentComplete,
    getSectionStatus,
    isSectionComplete,
    getSectionById,
  } = useOnboarding();

  const activeSections = sections.filter(s => !s.isComingSoon);
  const comingSoonSections = sections.filter(s => s.isComingSoon);
  const remainingCount = activeCount - completedCount;

  return {
    progress,
    sections,
    activeSections,
    comingSoonSections,
    completedCount,
    totalCount,
    activeCount,
    remainingCount,
    percentComplete,
    getSectionStatus,
    isSectionComplete,
    getSectionById,
  };
}
